var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Grid2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 9 C 3 10.093063 3.9069372 11 5 11 L 9 11 C 10.093063 11 11 10.093063 11 9 L 11 5 C 11 3.9069372 10.093063 3 9 3 L 5 3 z M 15 3 C 13.906937 3 13 3.9069372 13 5 L 13 9 C 13 10.093063 13.906937 11 15 11 L 19 11 C 20.093063 11 21 10.093063 21 9 L 21 5 C 21 3.9069372 20.093063 3 19 3 L 15 3 z M 5 5 L 9 5 L 9 9 L 5 9 L 5 5 z M 15 5 L 19 5 L 19 9 L 15 9 L 15 5 z M 5 13 C 3.9069372 13 3 13.906937 3 15 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 9 21 C 10.093063 21 11 20.093063 11 19 L 11 15 C 11 13.906937 10.093063 13 9 13 L 5 13 z M 15 13 C 13.906937 13 13 13.906937 13 15 L 13 19 C 13 20.093063 13.906937 21 15 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 15 C 21 13.906937 20.093063 13 19 13 L 15 13 z M 5 15 L 9 15 L 9 19 L 5 19 L 5 15 z M 15 15 L 19 15 L 19 19 L 15 19 L 15 15 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Grid2);
export default __webpack_public_path__ + "static/media/icons8-grid-2.a23b2c29.svg";
export { ForwardRef as ReactComponent };